import { css } from "@emotion/css";
import { type CalloutType, Callout, ExternalLink } from "@octopusdeploy/design-system-components";
import { fontWeight, space } from "@octopusdeploy/design-system-tokens";
import type { LicenseLimitUsage } from "@octopusdeploy/octopus-server-client";
import { LimitStatus } from "@octopusdeploy/octopus-server-client";
import { useAnalyticLicenseUsageDispatch } from "~/analytics/Analytics";
import type { LicenseMessageUrgency } from "~/components/Navbar/LicenseCountdownBanner";
interface LicenseUsageCalloutProps {
    limitUsage: LicenseLimitUsage;
}
export function LicenseUsageCallout({ limitUsage }: LicenseUsageCalloutProps) {
    const dispatchAction = useAnalyticLicenseUsageDispatch();
    if (limitUsage.LimitStatus === LimitStatus.UnderLimit)
        return null;
    const getCalloutData = (limitUsage: LicenseLimitUsage): {
        calloutTitle: string;
        calloutType: CalloutType;
        urgency: LicenseMessageUrgency;
    } => {
        const calloutType = limitUsage.LimitStatus === LimitStatus.AlmostAtLimit ? "warning" : "danger";
        const urgency = limitUsage.LimitStatus === LimitStatus.AlmostAtLimit ? "attention" : "danger";
        let calloutTitle = "";
        switch (limitUsage.LimitStatus) {
            case LimitStatus.AlmostAtLimit:
                calloutTitle = `You are approaching your ${limitUsage.Name.toLowerCase()} limit`;
                break;
            case LimitStatus.AtLimit:
                calloutTitle = `You have reached your ${limitUsage.Name.toLowerCase()} limit`;
                break;
            case LimitStatus.InOverrun:
            case LimitStatus.ExceedingLimit:
                calloutTitle = `You have exceeded your ${limitUsage.Name.toLowerCase()} limit`;
                break;
        }
        return { calloutTitle, calloutType, urgency };
    };
    const controlCenterAccountUrl = "https://oc.to/OctopusCloudAccount";
    const { calloutTitle, calloutType, urgency } = getCalloutData(limitUsage);
    const upgradeNowClicked = () => {
        dispatchAction("Click Upgrade Now in Control Center", { urgency: urgency, resource: limitUsage.Name });
    };
    return (<Callout title={calloutTitle} type={calloutType}>
            <div>{limitUsage.Message.replace(controlCenterAccountUrl, "Control Center")}</div>
            <div className={licenseUsageCalloutStyles.actions}>
                <ExternalLink href={"ControlCenter"} onClick={upgradeNowClicked}>
                    Upgrade Now in Control Center
                </ExternalLink>
            </div>
        </Callout>);
}
const licenseUsageCalloutStyles = {
    actions: css({
        marginTop: space[4],
        "& a": {
            fontWeight: fontWeight["700"],
        },
    }),
};
